<template>
    <v-list-item link style="align-self: flex-end" to="/logout">
        <v-list-item-icon>
            <v-icon color="red">mdi-power</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
    export default {
        name: "Logout"
    }
</script>

<style scoped>

</style>
